import React from "react";
import "./ContactingUs.css";
import { useNavigate } from "react-router-dom";

function ContactUs() {
  const navigate = useNavigate();
  return (
    <>
      <div className="contact-us">
        <p className="contactus-icon">
          <i className="fa-solid fa-bolt"></i> F & S Electric
        </p>
        <h3>Thank You for Contacting Us!</h3>
        <button onClick={() => navigate("/")}>Go to Home</button>
      </div>
    </>
  );
}

export default ContactUs;
